import { useHistory, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { VNDialog } from '../../VNCustomerFacingDisplay/components/VNDialog'
import { getCardAuthStepOne, getTransactionErrorDialog } from '../Selectors'
import { setCardAuthStepOne, setCustomerPayingWithCard, setTransactionErrorDialog } from '../ActionCreators'
import { sendRetryPayment } from '../../VNAndroidSDK/bridgeCalls/VNWebSDKDataSend'
import { clearCart } from '../../actions/cart'
import { clearPromotionsOnOrder } from '../../actions/promotion'
import { sendCFDScreenNav } from '../../VNAndroidSDK/bridgeCalls/VNWebSDKDataSend'
import { CFD_SCREEN } from '../../VNCustomerFacingDisplay/Reducer'
import { resetCFD } from '../../VNCustomerFacingDisplay/ActionCreators'
import useRemoteOrderTotal from '../../hooks/useRemoteOrderTotal'
import { isTabbed } from '../../utils/orderStates'
import { clearOrderInProgress } from '../../actions/order'
import { getOrderInProgress } from '../../selectors/order'
import { getBridgePaymentMethod } from '../../selectors/peripheral'
import { setBridgePaymentMethod } from '../../actions/peripheral'
import { bridgePaymentMethods } from '../../reducers/peripheral'
import { setShouldIncrementOrderNumber } from '../../VNOrders/ActionCreators'

export const VNTransactionErrorDialog = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { state } = useLocation()
  const fromSplit = state?.fromSplit ?? false
  const dialogOptions = useSelector((state) => getTransactionErrorDialog(state))
  const isOpen = dialogOptions?.get('open') || false
  const orderInProgress = useSelector((state) => getOrderInProgress(state))
  const [, , resetOrderTotals] = useRemoteOrderTotal()
  const authStepOne = useSelector(getCardAuthStepOne)
  const bridgePaymentMethod = useSelector((state) => getBridgePaymentMethod(state))

  if (!isOpen) return null

  return (
    <VNDialog
      open={isOpen}
      title={'Card Reader Status'}
      subTitle={dialogOptions?.get('subTitle')}
      primaryButtonText={'RETRY'}
      secondaryButtonText={'CANCEL'}
      onPrimaryButtonClick={() => {
        sendRetryPayment(bridgePaymentMethod)
        dispatch(setTransactionErrorDialog({ open: false }))
      }}
      onSecondaryButtonClick={() => {
        // error coming from auth request, keep cart contents
        if (bridgePaymentMethod === bridgePaymentMethods.executeAuthRequest) {
          dispatch(setTransactionErrorDialog({ open: false }))
          dispatch(setCardAuthStepOne({ open: false }))
          dispatch(setBridgePaymentMethod(bridgePaymentMethods.executeSaleRequest))
          sendCFDScreenNav(CFD_SCREEN.CART)
          return
        }

        // prevent aborting from Split Payment Flow
        if (fromSplit) {
          dispatch(setCustomerPayingWithCard({ open: false }))
          sendCFDScreenNav(CFD_SCREEN.SPLIT_PAY_WAITING_FOR_ATTENDANT)
          dispatch(setTransactionErrorDialog({ open: false }))
          return
        }

        // clear cart
        dispatch(setShouldIncrementOrderNumber())
        dispatch(clearCart())

        // clear promotions on order
        dispatch(clearPromotionsOnOrder())

        // reset order totals
        resetOrderTotals()

        // navigate CFD back to IDLE
        sendCFDScreenNav(CFD_SCREEN.IDLE)

        // navigate POS back to
        if (authStepOne?.get && !authStepOne.get('open')) {
          history.push('/concession-order')
        }

        // reset the state locally
        dispatch(resetCFD(true))

        dispatch(setCustomerPayingWithCard({ open: false }))
        dispatch(setCardAuthStepOne({ open: false }))

        dispatch(setBridgePaymentMethod(bridgePaymentMethods.executeSaleRequest))

        // close dialog
        dispatch(setTransactionErrorDialog({ open: false }))

        if (isTabbed(orderInProgress)) {
          dispatch(clearOrderInProgress())
        }
      }}
    />
  )
}
